/**
 * Shared leaderboard display helpers.
 */

const LEADERBOARD_SCOPES = new Set(["global", "country", "friends"]);

export function slugifyLeaderboardCountry(value) {
    const slug = String(value || "")
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+/, "");

    return slug.endsWith("-") ? slug.slice(0, -1) : slug;
}

export function parseLeaderboardSearch(search = "") {
    const params = new URLSearchParams(
        String(search || "").replace(/^\?/, ""),
    );

    if (params.has("country")) {
        return {
            scope: "country",
            country: String(params.get("country") || "").trim(),
        };
    }

    if (params.has("friends")) {
        return { scope: "friends", country: "" };
    }

    return { scope: "global", country: "" };
}

export function buildLeaderboardSearch(scope, country = "") {
    const resolvedScope = LEADERBOARD_SCOPES.has(scope) ? scope : "global";

    if (resolvedScope === "country") {
        const slug = slugifyLeaderboardCountry(country);
        return slug ? "?country=" + encodeURIComponent(slug) : "?country";
    }

    return resolvedScope === "friends" ? "?friends" : "?global";
}

export function isLeaderboardViewerRow(row, viewer) {
    if (!row?.userId || !viewer?.userId) return false;
    return String(row.userId) === String(viewer.userId);
}

export function formatTopPercentLabel(rank, totalPlayers) {
    if (
        !Number.isFinite(rank) ||
        !Number.isFinite(totalPlayers) ||
        rank < 1 ||
        totalPlayers < 1
    ) {
        return null;
    }
    const pct = (rank / totalPlayers) * 100;
    if (pct > 100) return null;

    return pct.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
    });
}
